/* tslint:disable */
/* eslint-disable */
/**
 * openapi
 * bales cloud
 *
 * The version of the OpenAPI document: 1.0
 * Contact: test@example.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { GetDefaultPromptSettings200Response } from '../models';
/**
 * DefaultPromptSettingApi - axios parameter creator
 * @export
 */
export const DefaultPromptSettingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 共通プロンプト設定一覧取得API
         * @summary 共通プロンプト設定一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultPromptSettings: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/default_prompt_settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 共通プロンプト設定作成API
         * @summary 共通プロンプト設定作成API
         * @param {GetDefaultPromptSettings200Response} [getDefaultPromptSettings200Response] 共通プロンプト設定登録APIのリクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDefaultPromptSettings: async (getDefaultPromptSettings200Response?: GetDefaultPromptSettings200Response, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/admin/default_prompt_settings`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(getDefaultPromptSettings200Response, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DefaultPromptSettingApi - functional programming interface
 * @export
 */
export const DefaultPromptSettingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DefaultPromptSettingApiAxiosParamCreator(configuration)
    return {
        /**
         * 共通プロンプト設定一覧取得API
         * @summary 共通プロンプト設定一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getDefaultPromptSettings(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetDefaultPromptSettings200Response>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getDefaultPromptSettings(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 共通プロンプト設定作成API
         * @summary 共通プロンプト設定作成API
         * @param {GetDefaultPromptSettings200Response} [getDefaultPromptSettings200Response] 共通プロンプト設定登録APIのリクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async postDefaultPromptSettings(getDefaultPromptSettings200Response?: GetDefaultPromptSettings200Response, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.postDefaultPromptSettings(getDefaultPromptSettings200Response, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * DefaultPromptSettingApi - factory interface
 * @export
 */
export const DefaultPromptSettingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DefaultPromptSettingApiFp(configuration)
    return {
        /**
         * 共通プロンプト設定一覧取得API
         * @summary 共通プロンプト設定一覧取得API
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getDefaultPromptSettings(options?: any): AxiosPromise<GetDefaultPromptSettings200Response> {
            return localVarFp.getDefaultPromptSettings(options).then((request) => request(axios, basePath));
        },
        /**
         * 共通プロンプト設定作成API
         * @summary 共通プロンプト設定作成API
         * @param {GetDefaultPromptSettings200Response} [getDefaultPromptSettings200Response] 共通プロンプト設定登録APIのリクエストボディ
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        postDefaultPromptSettings(getDefaultPromptSettings200Response?: GetDefaultPromptSettings200Response, options?: any): AxiosPromise<void> {
            return localVarFp.postDefaultPromptSettings(getDefaultPromptSettings200Response, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DefaultPromptSettingApi - interface
 * @export
 * @interface DefaultPromptSettingApi
 */
export interface DefaultPromptSettingApiInterface {
    /**
     * 共通プロンプト設定一覧取得API
     * @summary 共通プロンプト設定一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultPromptSettingApiInterface
     */
    getDefaultPromptSettings(options?: AxiosRequestConfig): AxiosPromise<GetDefaultPromptSettings200Response>;

    /**
     * 共通プロンプト設定作成API
     * @summary 共通プロンプト設定作成API
     * @param {GetDefaultPromptSettings200Response} [getDefaultPromptSettings200Response] 共通プロンプト設定登録APIのリクエストボディ
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultPromptSettingApiInterface
     */
    postDefaultPromptSettings(getDefaultPromptSettings200Response?: GetDefaultPromptSettings200Response, options?: AxiosRequestConfig): AxiosPromise<void>;

}

/**
 * Request parameters for postDefaultPromptSettings operation in DefaultPromptSettingApi.
 * @export
 * @interface DefaultPromptSettingApiPostDefaultPromptSettingsRequest
 */
export interface DefaultPromptSettingApiPostDefaultPromptSettingsRequest {
    /**
     * 共通プロンプト設定登録APIのリクエストボディ
     * @type {GetDefaultPromptSettings200Response}
     * @memberof DefaultPromptSettingApiPostDefaultPromptSettings
     */
    readonly getDefaultPromptSettings200Response?: GetDefaultPromptSettings200Response
}

/**
 * DefaultPromptSettingApi - object-oriented interface
 * @export
 * @class DefaultPromptSettingApi
 * @extends {BaseAPI}
 */
export class DefaultPromptSettingApi extends BaseAPI implements DefaultPromptSettingApiInterface {
    /**
     * 共通プロンプト設定一覧取得API
     * @summary 共通プロンプト設定一覧取得API
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultPromptSettingApi
     */
    public getDefaultPromptSettings(options?: AxiosRequestConfig) {
        return DefaultPromptSettingApiFp(this.configuration).getDefaultPromptSettings(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 共通プロンプト設定作成API
     * @summary 共通プロンプト設定作成API
     * @param {DefaultPromptSettingApiPostDefaultPromptSettingsRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DefaultPromptSettingApi
     */
    public postDefaultPromptSettings(requestParameters: DefaultPromptSettingApiPostDefaultPromptSettingsRequest = {}, options?: AxiosRequestConfig) {
        return DefaultPromptSettingApiFp(this.configuration).postDefaultPromptSettings(requestParameters.getDefaultPromptSettings200Response, options).then((request) => request(this.axios, this.basePath));
    }
}
